var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43274"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 106",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#0078E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.19998 15.6H22.8M7.19998 12H22.8M7.19998 19.2H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapseIcon.da8bdc79186ad457f148800877ea350d.svg";
export { ForwardRef as ReactComponent };